<template>
  <div class="statistics-panel" v-loading="loading">
    <!-- 活動篩選 -->
    <div class="stats-filter">
      <el-select
        v-model="filterAcId"
        placeholder="活動篩選"
        clearable
        size="small"
        style="width: 200px"
        @change="onFilterChange"
      >
        <el-option label="全部活動" value=""></el-option>
        <el-option v-for="item in activityOptions" :key="item.id" :label="item.titleAc" :value="item.id"></el-option>
      </el-select>
    </div>
    <!-- 统计卡片 -->
    <div class="stats-cards">
      <el-card class="stat-card" shadow="hover">
        <div class="card-inner">
          <div class="card-icon card-icon-total">
            <i class="el-icon-s-data"></i>
          </div>
          <div class="card-info">
            <div class="card-label">總留資數</div>
            <div class="card-value">{{ statsData.total || 0 }}</div>
          </div>
        </div>
      </el-card>
      <el-card class="stat-card" shadow="hover">
        <div class="card-inner">
          <div class="card-icon card-icon-today">
            <i class="el-icon-s-flag"></i>
          </div>
          <div class="card-info">
            <div class="card-label">今日新增</div>
            <div class="card-value highlight">{{ statsData.today || 0 }}</div>
          </div>
        </div>
      </el-card>
      <el-card class="stat-card" shadow="hover">
        <div class="card-inner">
          <div class="card-icon card-icon-week">
            <i class="el-icon-s-order"></i>
          </div>
          <div class="card-info">
            <div class="card-label">本週新增</div>
            <div class="card-value">{{ statsData.thisWeek || 0 }}</div>
          </div>
        </div>
      </el-card>
      <el-card class="stat-card" shadow="hover">
        <div class="card-inner">
          <div class="card-icon card-icon-month">
            <i class="el-icon-s-marketing"></i>
          </div>
          <div class="card-info">
            <div class="card-label">本月新增</div>
            <div class="card-value">{{ statsData.thisMonth || 0 }}</div>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 图表区域 -->
    <div class="charts-grid">
      <el-card class="chart-card" shadow="hover">
        <div slot="header" class="chart-header">
          <span>車型分佈</span>
        </div>
        <div ref="carModelChart" class="chart-box"></div>
      </el-card>
      <!-- <el-card class="chart-card" shadow="hover">
        <div slot="header" class="chart-header">
          <span>近30天留資趨勢</span>
        </div>
        <div ref="trendChart" class="chart-box"></div>
      </el-card> -->
      <!-- <el-card class="chart-card" shadow="hover">
        <div slot="header" class="chart-header">
          <span>時段分佈</span>
        </div>
        <div ref="timeChart" class="chart-box"></div>
      </el-card> -->
      <!-- <el-card class="chart-card" shadow="hover">
        <div slot="header" class="chart-header">
          <span>稱呼分佈</span>
        </div>
        <div ref="titleChart" class="chart-box"></div>
      </el-card> -->
      <el-card class="chart-card" shadow="hover">
        <div slot="header" class="chart-header">
          <el-radio-group v-model="trendTab" size="small" @change="onTrendTabChange">
            <el-radio-button label="7d">近7天（共 {{ total7 }} 筆）</el-radio-button>
            <el-radio-button label="30d">近30天（共 {{ total30 }} 筆）</el-radio-button>
          </el-radio-group>
        </div>
        <div ref="barChart" class="chart-box"></div>
      </el-card>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { rtsStatisticsApi, activityListApi, currentUrlListApi } from '@/Api/requestApi'
import moment from 'moment'

export default {
  name: 'StatisticsPanel',
  props: {
    brand: {
      type: String,
      default: 'icaur',
    },
    autoRefresh: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      filterAcId: '',
      activityOptions: [],
      statsData: {
        total: 0,
        today: 0,
        thisWeek: 0,
        thisMonth: 0,
      },
      trendChartInst: null,
      carModelChartInst: null,
      timeChartInst: null,
      titleChartInst: null,
      barChartInst: null,
      trendTab: '7d',
      total30: 0,
      total7: 0,
      daily30: [],
      daily7: [],
      resizeHandler: null,
    }
  },
  watch: {
    async brand() {
      this.fetchActivities()
      await this.fetchDefaultActivity()
      this.fetchData()
    },
    autoRefresh(val) {
      if (val) {
        this.fetchData()
      }
    },
  },
  mounted() {
    this.fetchActivities()
    this.fetchDefaultActivity().then(() => this.fetchData())
    this.resizeHandler = () => {
      this.trendChartInst?.resize()
      this.carModelChartInst?.resize()
      this.timeChartInst?.resize()
      this.titleChartInst?.resize()
      this.barChartInst?.resize()
    }
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
    this.trendChartInst?.dispose()
    this.carModelChartInst?.dispose()
    this.timeChartInst?.dispose()
    this.titleChartInst?.dispose()
    this.barChartInst?.dispose()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const params = { brand: this.brand }
        if (this.filterAcId) {
          params.acId = this.filterAcId
        }
        const { data } = await rtsStatisticsApi(params)
        if (data.code === 200) {
          const stats = data.data || {}
          console.log('stats:', stats)
          this.statsData = {
            total: stats.total || 0,
            today: stats.today || 0,
            thisWeek: stats.thisWeek || 0,
            thisMonth: stats.thisMonth || 0,
          }
          stats.dailyTrend = (stats.dailyTrend || []).map((d) => ({
            date: moment(d.date).format('YYYY-MM-DD '),
            count: d.count || 0,
          }))
          // 处理30天 / 7天趋势数据
          this.daily30 = (stats.dailyTrend30 || []).map((d) => ({
            date: moment(d.date).format('MM-DD'),
            count: d.count || 0,
          }))
          this.daily7 = (stats.dailyTrend7 || []).map((d) => ({
            date: moment(d.date).format('MM-DD'),
            count: d.count || 0,
          }))
          this.total30 = this.daily30.reduce((sum, d) => sum + d.count, 0)
          this.total7 = this.daily7.reduce((sum, d) => sum + d.count, 0)
          this.$nextTick(() => {
            this.initTrendChart(stats.dailyTrend || [])
            this.initCarModelChart(stats.carModelDist || [])
            this.initTimeChart(stats.timeDist || [])
            this.initTitleChart(stats.titleDist || [])
            this.initBarChart()
          })
        }
      } catch (err) {
        console.error('獲取統計數據失敗:', err)
      } finally {
        this.loading = false
      }
    },

    initTrendChart(dailyTrend) {
      if (!this.$refs.trendChart) return
      if (this.trendChartInst) this.trendChartInst.dispose()
      this.trendChartInst = echarts.init(this.$refs.trendChart)

      const dates = dailyTrend.map((d) => d.date) || []
      const counts = dailyTrend.map((d) => d.count) || []

      this.trendChartInst.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: '3%', right: '4%', bottom: '10%', top: '10%', containLabel: true },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dates,
          axisLabel: { rotate: 45, fontSize: 10 },
        },
        yAxis: { type: 'value', minInterval: 1 },
        series: [
          {
            name: '留資數',
            type: 'line',
            smooth: true,
            data: counts,
            itemStyle: { color: '#5b9bd5' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(91,155,213,0.35)' },
                { offset: 1, color: 'rgba(91,155,213,0.03)' },
              ]),
            },
            lineStyle: { width: 2 },
          },
        ],
      })
    },

    initCarModelChart(carModelDist) {
      if (!this.$refs.carModelChart) return
      if (this.carModelChartInst) this.carModelChartInst.dispose()
      this.carModelChartInst = echarts.init(this.$refs.carModelChart)

      const pieData = carModelDist.map((d) => ({
        name: d.name || '未知',
        value: d.count || 0,
      }))

      this.carModelChartInst.setOption({
        tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
        legend: { bottom: '0%' },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['50%', '45%'],
            avoidLabelOverlap: false,
            label: { show: false },
            emphasis: {
              label: { show: true, fontSize: 16, fontWeight: 'bold' },
            },
            data: pieData,
            color: [
              '#1976d2',
              '#7b1fa2',
              '#00838f',
              '#388e3c',
              '#f57c00',
              '#d32f2f',
              '#c2185b',
              '#f9a825',
              '#5d4037',
              '#546e7a',
            ],
          },
        ],
      })
    },

    initTimeChart(timeDist) {
      if (!this.$refs.timeChart) return
      if (this.timeChartInst) this.timeChartInst.dispose()
      this.timeChartInst = echarts.init(this.$refs.timeChart)

      const names = timeDist.map((d) => d.name) || []
      const counts = timeDist.map((d) => d.count) || []

      this.timeChartInst.setOption({
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: '3%', right: '10%', bottom: '10%', top: '10%', containLabel: true },
        xAxis: {
          type: 'category',
          data: names,
          axisLabel: { rotate: 30, fontSize: 9 },
        },
        yAxis: { type: 'value', minInterval: 1 },
        series: [
          {
            type: 'bar',
            data: counts,
            barWidth: '50%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#74b9ff' },
                { offset: 1, color: '#5b9bd5' },
              ]),
            },
          },
        ],
      })
    },

    initTitleChart(titleDist) {
      if (!this.$refs.titleChart) return
      if (this.titleChartInst) this.titleChartInst.dispose()
      this.titleChartInst = echarts.init(this.$refs.titleChart)

      const pieData = titleDist.map((d) => ({
        name: d.name || '未知',
        value: d.count || 0,
      }))

      this.titleChartInst.setOption({
        tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
        legend: { bottom: '0%' },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['50%', '45%'],
            avoidLabelOverlap: false,
            label: { show: false },
            emphasis: {
              label: { show: true, fontSize: 16, fontWeight: 'bold' },
            },
            data: pieData,
            color: ['#5b9bd5', '#fd79a8', '#6c5ce7', '#a29bfe', '#74b9ff'],
          },
        ],
      })
    },

    initBarChart() {
      if (!this.$refs.barChart) return
      if (this.barChartInst) this.barChartInst.dispose()
      this.barChartInst = echarts.init(this.$refs.barChart)
      const data = this.trendTab === '7d' ? this.daily7 : this.daily30
      const dates = data.map((d) => d.date) || []
      const counts = data.map((d) => d.count) || []
      this.barChartInst.setOption({
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: '3%', right: '4%', bottom: '10%', top: '10%', containLabel: true },
        xAxis: {
          type: 'category',
          data: dates,
          axisLabel: { rotate: 45, fontSize: 10 },
        },
        yAxis: { type: 'value', minInterval: 1 },
        series: [
          {
            name: '留資數',
            type: 'bar',
            data: counts,
            barMaxWidth: 24,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#a29bfe' },
                { offset: 1, color: '#6c5ce7' },
              ]),
              borderRadius: [4, 4, 0, 0],
            },
          },
        ],
      })
    },

    onTrendTabChange() {
      this.$nextTick(() => {
        this.initBarChart()
      })
    },
    onFilterChange() {
      sessionStorage.setItem(`rts_filterAcId_${this.brand}`, String(this.filterAcId || ''))
      this.fetchData()
    },
    async fetchActivities() {
      try {
        const { data } = await activityListApi({ brand: this.brand })
        if (data.code === 200) {
          this.activityOptions = data.data || []
        }
      } catch (err) {
        console.error('獲取活動列表失敗:', err)
      }
    },
    async fetchDefaultActivity() {
      const cacheKey = `rts_filterAcId_${this.brand}`
      const cached = sessionStorage.getItem(cacheKey)
      if (cached !== null) {
        this.filterAcId = cached === '' ? '' : Number(cached)
        return
      }
      try {
        const { data } = await currentUrlListApi({ brand: this.brand })
        if (data.code === 200 && data.data && data.data.length > 0) {
          this.filterAcId = data.data[0].curAcId || ''
        } else {
          this.filterAcId = ''
        }
      } catch (err) {
        console.error('獲取默認活動失敗:', err)
        this.filterAcId = ''
      }
      sessionStorage.setItem(cacheKey, String(this.filterAcId || ''))
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  .el-loading-spinner {
    flex-direction: column !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
}
.statistics-panel {
  padding: 0;
}

.stats-filter {
  margin-bottom: 16px;
}

.stats-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 20px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
}

.stat-card {
  ::v-deep .el-card__body {
    padding: 20px;
  }
}

.card-inner {
  display: flex;
  align-items: center;
  gap: 16px;
}

.card-icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #fff;

  &-total {
    background: linear-gradient(135deg, #1a1a2e, #16213e);
  }
  &-today {
    background: linear-gradient(135deg, #e94560, #c23152);
  }
  &-week {
    background: linear-gradient(135deg, #0f3460, #1a1a2e);
  }
  &-month {
    background: linear-gradient(135deg, #533483, #3b1f6e);
  }
}

.card-info {
  flex: 1;

  .card-label {
    font-size: 13px;
    color: #909399;
    margin-bottom: 4px;
  }

  .card-value {
    font-size: 28px;
    font-weight: 700;
    color: #333;

    &.highlight {
      color: #e94560;
    }
  }
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
}

.chart-card {
  ::v-deep .el-card__header {
    border-bottom: 1px solid #ebeef5;
    padding: 14px 20px;

    @media (max-width: 768px) {
      padding: 10px 14px;
    }
  }

  ::v-deep .el-card__body {
    padding: 0 8px 8px;

    @media (max-width: 768px) {
      padding: 0 4px 4px;
    }
  }
}

.chart-header {
  font-size: 15px;
  font-weight: 600;
  color: #333;

  @media (max-width: 768px) {
    font-size: 13px;
  }
}

.chart-box {
  width: 100%;
  height: 300px;

  @media (max-width: 768px) {
    height: 250px;
  }

  @media (max-width: 480px) {
    height: 220px;
  }
}
</style>
